import React from 'react';
import { Calendar, ChevronDown } from 'lucide-react';
import './DateRangeFilter.css';

const DateRangeFilter = ({ range, setRange, customDates, setCustomDates }) => {
    const options = [
        { id: '7d', label: 'Last 7 Days' },
        { id: '30d', label: 'Last 30 Days' },
        { id: '90d', label: 'Last 90 Days' },
        { id: 'all', label: 'All Time' },
        { id: 'custom', label: 'Custom Range' }
    ];

    return (
        <div className="date-filter-container">
            <div className="filter-dropdown-wrapper">
                <select
                    className="admin-dashboard-date-filter-select"
                    value={range}
                    onChange={(e) => setRange(e.target.value)}
                >
                    {options.map(opt => (
                        <option key={opt.id} value={opt.id}>
                            {opt.label}
                        </option>
                    ))}
                </select>
                <ChevronDown size={14} className="dropdown-arrow" />
            </div>

            {range === 'custom' && (
                <div className="custom-range-inputs">
                    <div className="range-field">
                        <Calendar size={14} className="field-icon" />
                        <input
                            type="date"
                            value={customDates.start}
                            onChange={(e) => setCustomDates({ ...customDates, start: e.target.value })}
                            className="date-input"
                        />
                    </div>
                    <span className="range-separator">to</span>
                    <div className="range-field">
                        <Calendar size={14} className="field-icon" />
                        <input
                            type="date"
                            value={customDates.end}
                            onChange={(e) => setCustomDates({ ...customDates, end: e.target.value })}
                            className="date-input"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DateRangeFilter;
